// http://s-ings.com/typicons/
import React from 'react';
import * as Typicons from 'react-icons/lib/ti'

const icons = [
  <Typicons.TiFlash />,
  <Typicons.TiHeart />,
  <Typicons.TiAnchor />,
  <Typicons.TiHome />,
  <Typicons.TiFlag />,
  <Typicons.TiKey />,
  <Typicons.TiCog />,
  <Typicons.TiHeadphones />,
  <Typicons.TiPen />,
  <Typicons.TiLockClosed />,
  <Typicons.TiNotes />,
  <Typicons.TiGift />,
  <Typicons.TiBell />,
  <Typicons.TiLeaf />
];

export { icons };